<template>
<div>   
    <section class="mt-5">
        <b-carousel :interval="4000"
                    background="#ababab">
          <b-carousel-slide :img-src="isMobile ? 'cantado/banner_mobil.jpg' : 'cantado/banner.jpg'">
          </b-carousel-slide>
        </b-carousel>
    </section>
    <hr>
    <div class="row justify-content-center" >
        <div class="col-md-5">
            <hr style="border-top: 5px solid #56CB00 !important;  opacity :0.8;">
        </div>
    </div>
    <div style="  margin-top: -12px; box-shadow: 0px 0px 10px 1px #AFAFAF;" id="fondo">
        <form @submit="login">
            <div class="text-center ">
                <div class="row justify-content-center">
                    <div class="col-md-11 mt-4">
                        <p>Ingresa los datos solicitados:</p>
                    </div>
                
                    <div class="col-md-3 mt-4">
                        <b-form-input placeholder="Correo"  v-model="email" type="text"  style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD;"/>
                        <small v-if="errors && errors['email']" class="text-danger mt-2">
                            <i class="fas fa-exclamation-circle"></i>
                            Este campo es obligatorio
                        </small>
                        <br>
                        <b-form-input placeholder="IDPDV"  v-model="idpdv" type="text"  style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD;"/>
                        <small v-if="errors && errors['id_pdv']" class="text-danger mt-2">
                            <i class="fas fa-exclamation-circle"></i>
                            Este campo es obligatorio
                        </small>
                        <br>
                        <b-form-input placeholder="AXC / MRT" v-model="mrt"  type="text"  style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD;"/>
                        <small v-if="errors && errors['password']" class="text-danger mt-2 text-left">
                            <i class="fas fa-exclamation-circle"></i>
                            Este campo es obligatorio
                        </small>
                    </div>
                    <div class="col-md-12">
                        <p v-if="errors && errors['general']" class="mt-4 lead text-danger">
                            <i class="fas fa-exclamation-circle"></i>
                            Datos incorrectos
                        </p>
                    </div>
                    <div class="col-md-6 mt-5 text-center">
                        <b-button type="submit" variant="primary" pill  style="margin-top: 25px; width: 20%;" size="sm" >
                            Ingresar  <b-spinner small v-if="loader"></b-spinner>
                        </b-button>
                        <br> <br> 
                        <br><br>                   
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="row justify-content-center" style="margin-top: -12px;">
        <div class="col-md-5">
            <hr style="border-top: 5px solid #56CB00 !important;  opacity :0.8;">
             <br> <br> 
             <br><br>  
        </div>
    </div>
</div>
</template>

<script>
export default {
    name:"embajador",
    data() {
        return {
          errors:[],
          loader:false,
          email:"",
          mrt:"",
          idpdv:"",
          isMobile: this.$mobile()
        }
    },
    methods:{
        login() {
            // e.preventDefault();
            this.errors = [];
            this.loader = true;
            var form = {};
            var url = "";

                form.mrt = this.$route.params.axc
                form.email = this.$route.params.correo
                url = "embajador";

            this.$api.post('auth/login/' + url, form, true).then(({data}) => {
                console.log(data.data);
                this.$store.dispatch("setLogin", data.data);
                this.$router.push("/");
                this.loader = false;
            }).catch(e => {
                console.log(e);
                this.loader = false;
                if (e.response.data.errors) {
                    this.errors = e.response.data.errors;
                } else {
                  alert("Ocurrió un error desconocido, vuelve a intentarlo más tarde")
                }
            });
        }
    },
    mounted(){
        this.login();
    }
}
</script>

<style>
 #fondo{
     background-image: url('../../../public/fotos/fondo.png');
     width: 100%!important;
    }
</style>